
















































































import Vue from "vue";
import User from "@/User";
import { PersistedEntity } from "@/types";
import LeadershipDialog from "@/components/arma/events/LeadershipDialog.vue";
import LotterySlotInterface from "@/types/LotterySlotInterface";
import UserChip from "@/components/users/UserChip.vue";

export default Vue.extend({
  components: {
    LeadershipDialog,
    UserChip
  },
  props: {
    lotterySlot: {
      required: true,
      type: Object as () => LotterySlotInterface & PersistedEntity,
    },
    divider: {
      required: false,
      default: true,
      type: Boolean,
    },
  },
  data() {
    return {
      loading: false,
      showLeadershipDialog: false,
      isModerator: false, // Reactive property to store the result
    };
  },
  computed: {
    icon(): string {
      return "mdi-dice-multiple-outline";
    },
    user() {
      return User.get();
    },
    containsCurrentUser(): boolean {
      return (
        this.user !== null && this.lotterySlot.discordUsers.find((user) => {
          return user.id === this.user!.id;
        }) !== undefined
      );
    },
  },
  async mounted() {
    // Call the async function and update the property
    this.isModerator = await User.isModerator();
  },

  methods: {
    handleSignUp(LotterySlot: LotterySlotInterface & PersistedEntity) {
      this.signUp(LotterySlot);
    },
    async signUp(LotterySlot: LotterySlotInterface & PersistedEntity) {
      this.loading = true;
      const slotEndpoint = "/arma/lotterySlots/";
      await this.axios.patch(slotEndpoint + LotterySlot.id);

      this.$emit("reload-event");
      this.loading = false;
    },
    async resolve() {
      this.loading = true;
      const slotEndpoint = "/arma/lotterySlots/";
      await this.axios.delete(slotEndpoint + this.lotterySlot.id);

      this.$emit("reload-event");
      this.loading = false;
    }
  },
});
